import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';

const LazyJsmCustomDomainChangeBoardingFlag = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-jsm-custom-domain-change-boarding-flag" */ './index'),
	{ entryFsSsrLiftImportToModule: false },
);

export const AsyncJsmCustomDomainChangeBoardingFlag = (): React.JSX.Element => (
	<JSErrorBoundary
		id="async-jsm-custom-domain-change-boarding-flag"
		packageName="jira-help-center-custom-domain-change-boarding"
	>
		<Placeholder name="jsm-custom-domain-change-boarding-flag" fallback={null}>
			<LazyJsmCustomDomainChangeBoardingFlag />
		</Placeholder>
	</JSErrorBoundary>
);
